module.exports = __webpack_public_path__ + "media/svg/arrow-right-circle-c90bf3ac.svg";